/* loaded by smart-asset */
export default require("./7a~RJzaPzJO.svg")